import { createContext, useContext } from 'react';
import type { tWorkspaceRuntime } from './Workspace.runtime';
import type { tWorkspaceAccess } from './data/contract/Workspace.generated';
import type { tConfigDraftSlot } from 'src/pages/LeadAgentConfig/data/source';

export type tWorkspaceAgentContext = (
  | {
      status: 'disabled' | 'loading' | 'unavailable';
      scope: string | null;
      retry: () => void;
    }
  | (tWorkspaceRuntime & {
      status: 'ready';
      access: tWorkspaceAccess;
      retry: () => void;
    })
) & { draft?: tConfigDraftSlot };
export const WorkspaceAgentContext = createContext<tWorkspaceAgentContext>({
  status: 'disabled',
  scope: null,
  retry: () => {},
});
export function useWorkspaceAgent() {
  return useContext(WorkspaceAgentContext);
}
